export default __webpack_public_path__ + "static/media/KES-Achievementwhite.03ea4f6b.png";